import axios from '../core/axios';
import { ApiConstants } from './api-constants';
import { WidgetConfigResponse, WidgetUpdatePayload } from '../model/widget.model';

export class WidgetService {
  static getWidgetConfig = async (): Promise<WidgetConfigResponse> => {
    return (await axios.get(ApiConstants.WIDGET_API.GET_CONFIG.URL())).data;
  };

  static updateWidgetConfig = async (
    widgetId: string,
    payload: WidgetUpdatePayload,
  ): Promise<void> => {
    await axios.patch(ApiConstants.WIDGET_API.UPDATE_CONFIG.URL(widgetId), payload);
  };
}
